import React, { useEffect, useState } from 'react';
import {
  Modal,
  Form,
  Input,
  message
} from 'antd';
import { createUser, updateUser } from '../../../../api/user';

const UserModal = ({ visible, record, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // 当弹窗打开时初始化表单
  useEffect(() => {
    if (visible) {
      if (record) {
        // 编辑模式，填充表单数据
        form.setFieldsValue({
          name: record.name,
          phone: record.phone,
          password: '' // 密码不回填，留空
        });
      } else {
        // 新增模式，重置表单
        form.resetFields();
      }
    }
  }, [visible, record, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (record) {
        // 编辑模式
        // 构建更新数据，phone 必传，name 和 password 可选
        const updateData = {
          phone: record.phone  // phone 作为识别用户的参数，固定传
        };
        
        // 如果 name 有值则添加
        if (values.name) {
          updateData.name = values.name;
        }
        
        // 如果 password 有值则添加（用户输入了新密码）
        if (values.password) {
          updateData.password = values.password;
        }
        
        await updateUser(updateData);
        message.success('更新用户成功');
      } else {
        // 新增模式
        await createUser(values);
        message.success('创建用户成功');
      }

      onSuccess();
    } catch (error) {
      if (error.errorFields) {
        message.error('请完善表单信息');
      } else {
        message.error(error.message || (record ? '更新用户失败' : '创建用户失败'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={record ? '编辑用户' : '创建用户'}
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
      okText="确定"
      cancelText="取消"
      destroyOnClose={false}
      forceRender
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="phone"
          label="手机号"
          rules={[
            { required: true, message: '请输入手机号' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
          ]}
        >
          <Input 
            placeholder="请输入手机号" 
            disabled={!!record} // 编辑时手机号不可修改
          />
        </Form.Item>
        
        <Form.Item
          name="name"
          label="姓名"
          rules={[
            { required: !record, message: '请输入姓名' }, // 新增时必填，编辑时可选
            { max: 20, message: '姓名不能超过20个字符' }
          ]}
        >
          <Input placeholder="请输入姓名" />
        </Form.Item>

        <Form.Item
          name="password"
          label="密码"
          rules={[
            { required: !record, message: '请输入密码' }, // 新增时必填
            { min: 6, message: '密码至少6位' }
          ]}
          extra={record ? '如不修改密码，请留空' : ''}
        >
          <Input.Password placeholder={record ? '不修改请留空' : '请输入密码'} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserModal;

